import _ from "lodash";

/**
 * 筛除params的空数据参数
 * @param params 
 * @returns 
 */
export const getParams = (params) => {
    return _.pickBy(params, _.identity);
};

/**
 * 将params的空数据参数变为空字符串
 * @param params 
 * @returns 
 */
export const getParamsWithNilToString = (params) => {
    const newParams = _.assign({}, params);
    for (const key in newParams) {
        if (_.isNil(newParams[key])) {
            newParams[key] = '';
        }
    }
    return newParams;
};